import { CommonMap } from 'client/tracking/maps/common';
import { GlobalSearchMap } from 'client/tracking/maps/global-search';
import { TrackingMap as SrpTrackingMap } from 'client/tracking/maps/inventory/srp';
import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';

import { HEADER_COMPONENT } from 'site-modules/personalized-search/constants/tracking';

const map = {
  view_features_specs: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_FEATURES_SPECS
  ),

  view_overview: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_REVIEW,
    TrackingConstant.ACTION_VIEW_CONTENT
  ),

  toggle_overview: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.ACTION_VIEW_CONTENT,
    { creative_id: HEADER_COMPONENT }
  ),

  opinion_button: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.ACTION_VIEW_CONTENT
  ),

  click_source_link: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, TrackingConstant.READ_MORE),
  select_photos: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SUBACTION_SELECT_PHOTOS
  ),
  view_review: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, TrackingConstant.ACTION_VIEW_REVIEW),
  select_survey: TrackingEvent.actionCompleted(TrackingConstant.ACTION_ENGAGE_SURVEY, TrackingConstant.SELECT_SURVEY),
  close_survey: TrackingEvent.actionCompleted(TrackingConstant.ACTION_ENGAGE_SURVEY, TrackingConstant.CLOSE_SURVEY),
  dismiss_survey: TrackingEvent.actionCompleted(TrackingConstant.ACTION_ENGAGE_SURVEY, TrackingConstant.DISMISS_SURVEY),
  dismiss_optional_write_in: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_ENGAGE_SURVEY,
    TrackingConstant.DISMISS_OPTIONAL_WRITE_IN
  ),
  view_dealer_details: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_DEALER_ENGAGEMENT,
    TrackingConstant.VIEW_DEALER_DETAILS
  ),
};

export const PersonalizedSearchMap = {
  ...CommonMap,
  ...GlobalSearchMap,
  ...SrpTrackingMap,
  ...map,
};
